import React from 'react';
import person5 from '../../../../assets/images/user-png-140.png';
import NewCard from './Modal/NewCard';
import Step1Details from './EnrollmentSteps/Step1Details';
import Step3EmployeeContract from './EnrollmentSteps/Step3EmployeeContract';
import Step4AccessRights from './EnrollmentSteps/Step4AccessRights';
import Step6CapturerFinger from './EnrollmentSteps/Step6CaptureFinger';
import Step7Card from './EnrollmentSteps/Step7Card';
import Step8Summary from './EnrollmentSteps/Step8Summary';
import FullPageLoader from '../../../../utils/FullPageLoader';
import routes from '../../../../Routes/routes';
import FingerPrintSpinner from './Modal/FingerPrintSpinner';
import HeadTittle from '../../../../components/HeadTittle';
import { ButtonNextStep, ButtonPrevStep } from '../../../../components/buttons/ButtonNavigation';
import StepperTabs from '../../../../components/StepperTabs/StepperTabs';
import Step2OtherDetails from './EnrollmentSteps/Step2OtherDetails';
import DivContainerBody from '../../../../components/DivContainerBody';
import ImagePreview from '../../../../components/ImagePreview';
import EmployeeApp from './Functionality/EmployeeApp';
import StepTab from '../../../../components/StepperTabs/StepTab';
import CopySecretModal from './Modal/CopySecretModal';
import {permissionObj} from "../../../../Helpers/permission";
import {ACTION_MODEL} from '../../../../Helpers/ActionModel';
import {FILE_TYPE} from '../../../../Helpers/fileType';
import {SUGGESTION_MODE_OPTION} from '../../../../components/PhotoPicker/SubComponent/Models/Models';
import CustomPhotoPicker from '../../../../components/PhotoPicker/CustomPhotoPicker';
import ButtonIcon from "../../../../components/buttons/ButtonIcon";
import {CleanIcon} from "../../../../components/buttons/IconButtons";

const CreateEmployee = () => {
    const {
        contractorId,
        supplierId,
        DEV,
        permission,
        navigate,
        disabled,
        headersList,
        employeeRoles,
        employeeWorkStations,
        contractStatusList,
        employeeDepartments,
        steps,
        activeStep,
        setActiveStep,
        loadingProgress,
        setLoadingProgress,
        imageToUpload,
        extraDataEnabled,
        emptyFields,
        userData,
        setUserData,
        isValidEmail,
        isValidDocumentId,
        isValidPin,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        createEmployeeEmail,
        extraData,
        setExtraData,
        employeeData,
        setEmployeeData,
        isValidStartDate,
        setIsValidStartDate,
        isValidEndDate,
        setIsValidEndDate,
        workShiftsList,
        setWorkShiftsList,
        customizedList,
        setCustomizedList,
        selectedReader,
        setSelectedReader,
        availableReaders,
        setAvailableReaders,
        capturedFingerprint,
        setCapturedFingerprint,
        fingerprintsList,
        fingerprintName,
        setFingerprintName,
        fingerprintSrc,
        setFingerprintSrc,
        updated,
        setUpdated,
        updatedFinger,
        setUpdatedFinger,
        capturing,
        setCapturing,
        selfieSrc,
        selectedImage,
        setCardData,
        cardDataInfo,
        setCardDataInfo,
        newCardModal,
        setNewCardModal,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        generatedPassword,
        setModified,
        photoPickerFile,
        setPhotoPickerFile,
        cardsList,
        setCardsList,
        handleCloseModal,
        handleFormChangeUserData,
        handleFormChangeExtraData,
        handleFormChangeEmployeeData,
        handleStepChange,
        handleCreateEmployee,
        handleClearExtraData,
        handleClearUserData,
        handleClearEmployeeData,
        getAvailableReaders,
        handleUploadFinger,
        handleValidationStepDetails,
        handleValidationContract,
        handleValidationFinger,
        isPilgrimsValidation,
        handleValidationSelfie,
        emptySelfie,
        isValidCecoCode
    } = EmployeeApp();

    if(contractorId === null && supplierId === null && !DEV && !permission?.includes(permissionObj?.WEB_EMPLOYEE_CREATE)) navigate(routes.forbidden);

    return (
        <>
            {loadingProgress && <FullPageLoader />}
            {capturing && <FingerPrintSpinner onClose={handleCloseModal} capturing={capturing} />}
            <HeadTittle link={routes.employee.list} name={'create'} />

            <DivContainerBody>
                <ImagePreview className={'mb-4 justify-content-center'} preview={imageToUpload === null ? person5 : imageToUpload} />

                {extraDataEnabled ? (
                    <>
                        <StepperTabs
                            disabled={disabled}
                            id={null}
                            steps={steps}
                            activeStep={activeStep}
                            isStepOptional={() => {}}
                            setActiveStep={setActiveStep}
                            handleStepChange={handleStepChange}
                        >
                            <StepTab index={0} activeStep={activeStep} normalHeight={true}>
                                <div className='col-12 d-flex justify-content-end mb-2'>
                                    <ButtonIcon
                                        className='btn-clean-secondary-600'
                                        id='btn_ce_clean'
                                        Icon={CleanIcon}
                                        title={'clear_instances'}
                                        iconProps={'btn-icon-svg-12px icon-color-general-00'}
                                        onClick={() => {
                                            handleClearUserData();

                                        }}
                                    />
                                </div>
                                <Step1Details
                                    userData={userData}
                                    onChange={handleFormChangeUserData}
                                    emptyFields={emptyFields}
                                    isValidEmail={isValidEmail}
                                    isValidDocumentId={isValidDocumentId}
                                    isValidPhoneNumber={isValidPhoneNumber}
                                    isValidDob={isValidDob}
                                    setIsValidDob={setIsValidDob}
                                    isValidPin={isValidPin}
                                    createEmployeeEmail={createEmployeeEmail}
                                />
                                <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                                    <ButtonNextStep
                                        id='btn_ce_next_details'
                                        text='next'
                                        click={() => {
                                            handleValidationStepDetails();
                                        }}
                                    />
                                </div>
                            </StepTab>
                            <StepTab index={1} activeStep={activeStep} normalHeight={true}>
                                <Step2OtherDetails
                                    showBtnClean={userData?.id == null || userData?.id == ''}
                                    extraData={extraData}
                                    onChange={handleFormChangeExtraData}
                                    setExtraData={setExtraData}
                                    headersList={headersList}
                                    handleClearExtraData={handleClearExtraData}
                                />

                                <div className='col-12 d-flex justify-content-between mt-3'>
                                    <ButtonPrevStep
                                        id='btn_ce_back_other_details'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_ce_next_other_details'
                                        text='next'
                                        disabled={activeStep === steps.length - 1}
                                        click={() => setActiveStep((prevStep) => prevStep + 1)}
                                    />
                                </div>
                            </StepTab>
                            <StepTab index={2} activeStep={activeStep} normalHeight={true}>
                                <Step3EmployeeContract
                                    employeeData={employeeData}
                                    employeeRoles={employeeRoles}
                                    employeeWorkStations={employeeWorkStations}
                                    contractStatusList={contractStatusList}
                                    employeeDepartments={employeeDepartments}
                                    emptyFields={emptyFields}
                                    isValidStartDate={isValidStartDate}
                                    setIsValidStartDate={setIsValidStartDate}
                                    isValidEndDate={isValidEndDate}
                                    setIsValidEndDate={setIsValidEndDate}
                                    onChange={handleFormChangeEmployeeData}
                                    setEmployeeData={setEmployeeData}
                                    handleClearEmployeeData={handleClearEmployeeData}
                                    isPilgrimsValidation={isPilgrimsValidation}
                                    isValidCecoCode={isValidCecoCode}
                                />
                                <div className='col-12 d-flex justify-content-between mt-3'>
                                    <ButtonPrevStep
                                        id='btn_ce_back_contract'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_ce_next_contract'
                                        text='next'
                                        disabled={activeStep === steps.length - 1}
                                        click={() => {
                                            handleValidationContract();
                                        }}
                                    />
                                </div>
                            </StepTab>
                            <StepTab index={3} activeStep={activeStep} normalHeight={true}>
                                <Step4AccessRights
                                    userData={userData}
                                    employeeData={employeeData}
                                    workShiftsList={workShiftsList}
                                    setWorkShiftsList={setWorkShiftsList}
                                    customizedList={customizedList}
                                    setCustomizedList={setCustomizedList}
                                    onChange={handleFormChangeEmployeeData}
                                    setEmployeeData={setEmployeeData}
                                    isEditable={true}
                                />
                                <div className='col-12 d-flex justify-content-between mt-3'>
                                    <ButtonPrevStep
                                        id='btn_ce_back_access_rights'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_ce_next_access_rights'
                                        text='next'
                                        disabled={activeStep === steps.length - 1}
                                        click={() => setActiveStep((prevStep) => prevStep + 1)}
                                    />
                                </div>
                            </StepTab>
                            <StepTab index={4} activeStep={activeStep} normalHeight={true}>
                                {activeStep == 4 &&
                                    <CustomPhotoPicker
                                        id='fp_ce_create_photo_profile'
                                        photoPicker={photoPickerFile}
                                        setPhotoPicker={setPhotoPickerFile}
                                        actionModel={ACTION_MODEL.CREATE}
                                        accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                                        showBtnCamera={true}
                                        validateFace={true}
                                        emptyFields={emptySelfie}
                                        classWith={'content-center-w-400px'}
                                        showPreview={true}
                                        disabled={disabled}
                                        required={isPilgrimsValidation}
                                        typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                                    />
                                }
                                <div className='col-12 d-flex justify-content-between mt-3'>
                                    <ButtonPrevStep
                                        id='btn_ce_back_selfie'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_ce_next_selfie'
                                        text='next'
                                        disabled={activeStep === steps.length - 1}
                                         click={() => {
                                            handleValidationSelfie();
                                        }}
                                    />
                                </div>
                            </StepTab>
                            <StepTab index={5} activeStep={activeStep} normalHeight={true}>
                                <Step6CapturerFinger
                                    employeeData={employeeData}
                                    userData={userData}
                                    onChange={handleFormChangeEmployeeData}
                                    selectedReader={selectedReader}
                                    setSelectedReader={setSelectedReader}
                                    availableReaders={availableReaders}
                                    setAvailableReaders={setAvailableReaders}
                                    getAvailableReaders={getAvailableReaders}
                                    setCapturedFingerprint={setCapturedFingerprint}
                                    capturedFingerprint={capturedFingerprint}
                                    fingerprintSrc={fingerprintSrc}
                                    fingerprintsList={fingerprintsList}
                                    handleUploadFinger={handleUploadFinger}
                                    fingerprintName={fingerprintName}
                                    setFingerprintName={setFingerprintName}
                                    setFingerprintSrc={setFingerprintSrc}
                                    updated={updated}
                                    setUpdated={setUpdated}
                                    updatedFinger={updatedFinger}
                                    setUpdatedFinger={setUpdatedFinger}
                                    loadingProgress={loadingProgress}
                                    setLoadingProgress={setLoadingProgress}
                                    capturing={capturing}
                                    setCapturing={setCapturing}
                                    emptyFields={emptyFields}
                                    setEmployeeData={setEmployeeData}
                                    setModified={setModified}
                                />
                                <div className='col-12 d-flex justify-content-between mt-3'>
                                    <ButtonPrevStep
                                        id='btn_ce_back_finger'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_ce_next_finger'
                                        text='next'
                                        disabled={activeStep === steps.length - 1}
                                        click={() => {
                                            handleValidationFinger();
                                        }}
                                    />
                                </div>
                            </StepTab>
                            <StepTab index={6} activeStep={activeStep} normalHeight={true}>
                                <Step7Card
                                    cardsList={cardsList}
                                    setCardsList={setCardsList}
                                    setCardData={setCardData}
                                    setCardDataInfo={setCardDataInfo}
                                    componentAction='create'
                                />
                                <div className='col-12 d-flex justify-content-between mt-3'>
                                    <ButtonPrevStep
                                        id='btn_ce_back_card'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_ce_next_card'
                                        text='next'
                                        disabled={activeStep === steps.length - 1}
                                        click={() => setActiveStep((prevStep) => prevStep + 1)}
                                    />
                                </div>
                            </StepTab>
                            <StepTab index={7} activeStep={activeStep} normalHeight={true}>
                                {activeStep == 7 && (
                                    <Step8Summary
                                        userData={userData}
                                        extraData={extraData}
                                        employeeRoles={employeeRoles}
                                        employeeWorkStations={employeeWorkStations}
                                        contractStatusList={contractStatusList}
                                        employeeDepartments={employeeDepartments}
                                        workShiftsList={workShiftsList}
                                        customizedList={customizedList}
                                        onChange={handleFormChangeEmployeeData}
                                        extraDataEnabled={extraDataEnabled}
                                        employeeData={employeeData}
                                        selectedImage={selectedImage}
                                        selfieSrc={selfieSrc}
                                        fingerprintSrc={fingerprintSrc}
                                        fingerprintName={fingerprintName}
                                        headersList={headersList}
                                        cardDataInfo={cardDataInfo}
                                        photoPicker={photoPickerFile}
                                        isPilgrimsValidation={isPilgrimsValidation}
                                    />
                                )}

                                <div className='col-12 d-flex justify-content-between mt-3'>
                                    <ButtonPrevStep
                                        id='btn_ce_back_summary'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_ce_enroll'
                                        text='create'
                                        click={() => {
                                            handleCreateEmployee();
                                        }}
                                    />
                                </div>
                            </StepTab>
                        </StepperTabs>
                    </>
                ) : (
                    <>
                        <StepperTabs
                            disabled={disabled}
                            id={null}
                            steps={steps}
                            activeStep={activeStep}
                            isStepOptional={() => {}}
                            setActiveStep={setActiveStep}
                            handleStepChange={handleStepChange}
                        >
                            <StepTab index={0} activeStep={activeStep} normalHeight={true}>
                                <div className='col-12 d-flex justify-content-end mb-2'>
                                    <ButtonIcon
                                        className='btn-clean-secondary-600'
                                        id='btn_ce_clean'
                                        Icon={CleanIcon}
                                        title={'clear_instances'}
                                        iconProps={'btn-icon-svg-12px icon-color-general-00'}
                                        onClick={() => {
                                            handleClearUserData();
                                        }}
                                    />
                                </div>
                                <Step1Details
                                    userData={userData}
                                    onChange={handleFormChangeUserData}
                                    emptyFields={emptyFields}
                                    isValidEmail={isValidEmail}
                                    isValidDocumentId={isValidDocumentId}
                                    isValidPhoneNumber={isValidPhoneNumber}
                                    isValidDob={isValidDob}
                                    setIsValidDob={setIsValidDob}
                                    isValidPin={isValidPin}
                                    createEmployeeEmail={createEmployeeEmail}
                                />
                                <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                                    <ButtonNextStep
                                        id='btn_ce_next_details'
                                        text='next'
                                        click={() => {
                                            handleValidationStepDetails();
                                        }}
                                    />
                                </div>
                            </StepTab>
                            <StepTab index={1} activeStep={activeStep} normalHeight={true}>
                                <Step3EmployeeContract
                                    employeeData={employeeData}
                                    employeeRoles={employeeRoles}
                                    employeeWorkStations={employeeWorkStations}
                                    contractStatusList={contractStatusList}
                                    employeeDepartments={employeeDepartments}
                                    emptyFields={emptyFields}
                                    isValidStartDate={isValidStartDate}
                                    setIsValidStartDate={setIsValidStartDate}
                                    isValidEndDate={isValidEndDate}
                                    setIsValidEndDate={setIsValidEndDate}
                                    onChange={handleFormChangeEmployeeData}
                                    setEmployeeData={setEmployeeData}
                                    handleClearEmployeeData={handleClearEmployeeData}
                                    isPilgrimsValidation={isPilgrimsValidation}
                                    isValidCecoCode={isValidCecoCode}
                                />
                                <div className='col-12 d-flex justify-content-between mt-3'>
                                    <ButtonPrevStep
                                        id='btn_ce_back_contract'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_ce_next_contract'
                                        text='next'
                                        disabled={activeStep === steps.length - 1}
                                        click={() => {
                                            handleValidationContract();
                                        }}
                                    />
                                </div>
                            </StepTab>
                            <StepTab index={2} activeStep={activeStep} normalHeight={true}>
                                <Step4AccessRights
                                    userData={userData}
                                    employeeData={employeeData}
                                    workShiftsList={workShiftsList}
                                    setWorkShiftsList={setWorkShiftsList}
                                    customizedList={customizedList}
                                    setCustomizedList={setCustomizedList}
                                    onChange={handleFormChangeEmployeeData}
                                    setEmployeeData={setEmployeeData}
                                    isEditable={true}
                                />
                                <div className='col-12 d-flex justify-content-between mt-3'>
                                    <ButtonPrevStep
                                        id='btn_ce_back_rights'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_ce_next_rights'
                                        text='next'
                                        disabled={activeStep === steps.length - 1}
                                        click={() => setActiveStep((prevStep) => prevStep + 1)}
                                    />
                                </div>
                            </StepTab>
                            <StepTab index={3} activeStep={activeStep} normalHeight={true}>
                                {activeStep == 3 &&
                                    <CustomPhotoPicker
                                        id='fp_ce_create_photo_profile'
                                        photoPicker={photoPickerFile}
                                        setPhotoPicker={setPhotoPickerFile}
                                        actionModel={ACTION_MODEL.CREATE}
                                        accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                                        showBtnCamera={true}
                                        validateFace={true}
                                        classWith={'content-center-w-400px'}
                                        showPreview={true}
                                        disabled={disabled}
                                        required={isPilgrimsValidation}
                                        emptyFields={emptySelfie}
                                        typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                                    />
                                }
                                <div className='col-12 d-flex justify-content-between mt-3'>
                                    <ButtonPrevStep
                                        id='btn_ce_back_selfie'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_ce_next_selfie'
                                        text='next'
                                        disabled={activeStep === steps.length - 1}
                                        click={() => {
                                            handleValidationSelfie();
                                        }}
                                    />
                                </div>
                            </StepTab>
                            <StepTab index={4} activeStep={activeStep} normalHeight={true}>
                                <Step6CapturerFinger
                                    employeeData={employeeData}
                                    userData={userData}
                                    onChange={handleFormChangeEmployeeData}
                                    selectedReader={selectedReader}
                                    setSelectedReader={setSelectedReader}
                                    setCapturedFingerprint={setCapturedFingerprint}
                                    capturedFingerprint={capturedFingerprint}
                                    availableReaders={availableReaders}
                                    setAvailableReaders={setAvailableReaders}
                                    getAvailableReaders={getAvailableReaders}
                                    fingerprintSrc={fingerprintSrc}
                                    fingerprintsList={fingerprintsList}
                                    handleUploadFinger={handleUploadFinger}
                                    fingerprintName={fingerprintName}
                                    setFingerprintName={setFingerprintName}
                                    setFingerprintSrc={setFingerprintSrc}
                                    updated={updated}
                                    setUpdated={setUpdated}
                                    updatedFinger={updatedFinger}
                                    setUpdatedFinger={setUpdatedFinger}
                                    loadingProgress={loadingProgress}
                                    setLoadingProgress={setLoadingProgress}
                                    capturing={capturing}
                                    setCapturing={setCapturing}
                                    emptyFields={emptyFields}
                                    setEmployeeData={setEmployeeData}
                                    setModified={setModified}
                                />
                                <div className='col-12 d-flex justify-content-between mt-3'>
                                    <ButtonPrevStep
                                        id='btn_ce_back_finger'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_ce_next_finger'
                                        text='next'
                                        disabled={activeStep === steps.length - 1}
                                        click={() => {
                                            handleValidationFinger();
                                        }}
                                    />
                                </div>
                            </StepTab>
                            <StepTab index={5} activeStep={activeStep} normalHeight={true}>
                                <Step7Card
                                    cardsList={cardsList}
                                    setCardsList={setCardsList}
                                    setCardData={setCardData}
                                    setCardDataInfo={setCardDataInfo}
                                    componentAction='create'
                                />
                                <div className='col-12 d-flex justify-content-between mt-3'>
                                    <ButtonPrevStep
                                        id='btn_ce_back_card'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_ce_next_card'
                                        text='next'
                                        disabled={activeStep === steps.length - 1}
                                        click={() => setActiveStep((prevStep) => prevStep + 1)}
                                    />
                                </div>
                            </StepTab>
                            <StepTab index={6} activeStep={activeStep} normalHeight={true}>
                                <Step8Summary
                                    userData={userData}
                                    extraData={extraData}
                                    employeeRoles={employeeRoles}
                                    employeeWorkStations={employeeWorkStations}
                                    contractStatusList={contractStatusList}
                                    employeeDepartments={employeeDepartments}
                                    workShiftsList={workShiftsList}
                                    customizedList={customizedList}
                                    onChange={handleFormChangeEmployeeData}
                                    extraDataEnabled={extraDataEnabled}
                                    employeeData={employeeData}
                                    selectedImage={selectedImage}
                                    selfieSrc={selfieSrc}
                                    fingerprintSrc={fingerprintSrc}
                                    fingerprintName={fingerprintName}
                                    headersList={headersList}
                                    cardDataInfo={cardDataInfo}
                                    photoPicker={photoPickerFile}
                                    isPilgrimsValidation={isPilgrimsValidation}
                                />
                                <div className='col-12 d-flex justify-content-between mt-3'>
                                    <ButtonPrevStep
                                        id='btn_ce_back_summary'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_ce_enroll'
                                        text='create'
                                        click={() => {
                                            handleCreateEmployee();
                                        }}
                                    />
                                </div>
                            </StepTab>
                        </StepperTabs>
                    </>
                )}
            </DivContainerBody>
            <NewCard title='New Card' show={newCardModal} onHide={() => setNewCardModal(false)} />

            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUserData}
                generatedPassword={generatedPassword}
                onHide={() => {
                    navigate(routes.employee.list);
                }}
                closeText={'continue'}
            />
        </>
    );
};
export default CreateEmployee;
